module.exports = __webpack_public_path__ + "img/bg-img.bd564511.svg";